<div class="page_main_sec paddingLeft page_main_sec_help">
    <div class="bannerLeaderBoard">
        <div class="bannerImg">
            <img class="bannerDefault" src="../../../assets/img/banner-leader-def.png" alt="Leader">
            <img class="bannerTML" src="../../../assets/img/banner-leader.png" alt="Leader">
            <h2 class="leaderName">Hi {{currentUser}}! How can I help you?</h2>
        </div>
    </div>
    <div class="shadowBox">
        <div class="search-filter-v01">
            <div class="formRow">
                <div class="inputBox">
                    <input id="input1" type="search" placeholder="Search the Help Center"><i class="bi bi-search"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="helpList">
        <h3>Choose a category to find the help you need</h3>
        <div class="shadowBox">
            <ul>
                <li *ngFor="let field of lstHelpDataByRole;let fieldIndex=index;">
                    <span>
                        <img [src]="field.icon" alt="field.Category" class="imgDef help-default Cur" (click)="getHelpSection(field.Category)">
                        <img [src]="field.icon" alt="field.Category" (click)="getHelpSection(field.Category)" class="imgDef help-tml Cur">
                    </span>
                    <br>
                    <span class="spancontent" (click)="getHelpSection(field.Category)">{{field.Category}}</span>

                </li>
                <!-- <li>
                        <span>
                            <img src="../../../assets/img/help-invoice-creation-def.svg" alt="Invoice Creation" class="imgDef help-default">
                            <img src="../../../assets/img/help-invoice-creation-tml.png" alt="Invoice Creation" class="imgDef help-tml">

                        </span>
                        <br>
                        <span #invoice (click)="getHelpSection(invoice)">Invoice creation and submission</span>
                    </li>
                    <li>
                        <span>
                            <img src="../../../assets/img/help-tracking-def.svg" alt="Tracking Status" class="imgDef help-default">
                            <img src="../../../assets/img/report-tml.png" alt="Tracking Status" class="imgDef help-tml">
                        </span>
                        <br>
                        <span  #tracking (click)="getHelpSection(tracking)">Tracking Status</span>
                    </li>
                    <li>
                        <span>
                            <img src="../../../assets/img/help-report-data-def.svg" alt="Downloading Report Data" class="imgDef help-default">
                            <img src="../../../assets/img/download-tml.png" alt="Downloading Report Data" class="imgDef help-tml">
                        </span>
                        <br>
                        <span  #download (click)="getHelpSection(download)">Downloading Report Data</span>
                    </li>
                    <li>
                        <span>
                            <img src="../../../assets/img/help-video-def.svg" alt="Videos" class="imgDef help-default">
                            <img src="../../../assets/img/video-tml.png" alt="Videos" class="imgDef help-tml">
                        </span>
                        <br>
                        <span  #video (click)="getHelpSection(video)">Videos</span>
                    </li> -->
            </ul>
        </div>
        <!-- <app-basic-gridview *ngIf="lstHelpData.length > 0" [lstData]="lstHelpData" [showExcelDownloadOption]="false"
            [showSearchOption]="false" [showRecordsPerPageOption]="false" [showPagination]="false">
        </app-basic-gridview> -->
        <!-- <pre>Helpsection:{{lstHelpData | json}}</pre> -->
    </div>
</div>